import { Button, Stack, TextField, Typography } from "@mui/material"
import { useScanBarcode } from "../Barcode/custom-hooks"
import { useState } from "react"

export const ScanBarcode = ({ onComplete, height = '500px' }) => {
    const [card, setCard] = useState('')

    const handler = async (event) => {
        event.preventDefault()
        scanned(card)
    }

    const scanned = async (barcode) => {
        if (barcode === '') return

        console.log('Scanned:', barcode)
        await onComplete(barcode)
        setCard('')
    }

    useScanBarcode({
        onComplete: scanned
    })

    return (
        <Stack direction='column' justifyContent='space-between'>
            <Stack alignItems='center' justifyContent='center' height={height}>
                <Typography>Esperando lectura...</Typography>
                {
                    process.env.REACT_APP_STAGE !== 'prod' &&
                    <div>
                        <Button onClick={() => onComplete('0008')}>Fake-Good</Button>
                        <Button onClick={() => onComplete('0009')}>Fake-Bad</Button>
                    </div>
                }
            </Stack>
            <form
                onSubmit={handler}
            >
                <Stack direction='row' gap='.5rem' justifyContent='end' alignItems='center'>
                    <TextField
                        size='small'
                        label='Código de Hermano'
                        value={card}
                        onChange={(event) => setCard(event.target.value)}
                    />
                    <div>
                        <Button size='small' variant='contained' type='submit'>Aceptar</Button>
                    </div>
                </Stack>
            </form>
        </Stack>
    )
}